import httpClient from '../httpClient';

export interface ApprovalConfig {
  requiresApproval: boolean;
  approverType?: 'user' | 'email';
  approverUuid?: string | null;
  approverEmail?: string | null;
  approverName?: string | null;
  status?: 'pending' | 'approved' | 'rejected' | 'notified';
}

export interface MyApproval {
  id: number;
  courseId: number;
  courseTitle: string;
  courseStatus: string;
  status: string;
  requestedAt: string | null;
  requestedByName: string | null;
}

interface ApiResponse<T> { success: boolean; data: T; message?: string; }

const SA = '/super-admin/content-governance/courses';

const ok = <T,>(data?: T, message?: string) =>
  ({ success: true as const, data, message, error: null as { message: string } | null });
const err = (e: any) =>
  ({ success: false as const, data: undefined, message: undefined, error: { message: e?.response?.data?.message ?? e?.message ?? 'Request failed' } });

// ---- Super-admin: configure + send ----

export const saveApprovalConfig = async (
  courseId: number,
  cfg: { requiresApproval: boolean; approverUuid?: string | null; approverEmail?: string | null }
) => {
  try {
    const res = await httpClient.put<ApiResponse<unknown>>(`${SA}/${courseId}/approval-config`, cfg);
    return ok(res.data, res.message);
  } catch (e) { return err(e); }
};

export const getApprovalConfig = async (courseId: number) => {
  try {
    const res = await httpClient.get<ApiResponse<ApprovalConfig>>(`${SA}/${courseId}/approval-config`);
    return ok(res.data);
  } catch (e) { return err(e); }
};

export const requestApproval = async (courseId: number) => {
  try {
    const res = await httpClient.post<ApiResponse<unknown>>(`${SA}/${courseId}/request-approval`, {});
    return ok(res.data, res.message);
  } catch (e) { return err(e); }
};

// ---- Approver inbox ----

export const getMyApprovals = async () => {
  try {
    const res = await httpClient.get<ApiResponse<MyApproval[]>>('/course-approvals/mine');
    return ok(res.data ?? []);
  } catch (e) { return err(e); }
};

export const decideApproval = async (id: number, decision: 'approve' | 'reject', note?: string) => {
  try {
    const res = await httpClient.post<ApiResponse<unknown>>(`/course-approvals/${id}/decide`, { decision, note });
    return ok(res.data, res.message);
  } catch (e) { return err(e); }
};
